import { apiWrapper } from '../helper/api-wrapper';

export const getListStyle = async (payload) => {
  try {
    const response = await apiWrapper.post('merchant/product/tag', payload);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getListRoomStyle = async () => {
  try {
    const response = await apiWrapper.get('merchants/master/room_style');

    return response;
  } catch (error) {
    throw error;
  }
};

export const getListProject = async (payload) => {
  try {
    const response = await apiWrapper.post(
      'merchant/designer/project/list',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getListProjectLatest = async (payload) => {
  try {
    const response = await apiWrapper.post(
      'merchant/designer/project/latestProject',
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getListDesignConceptLatest = async () => {
  try {
    const response = await apiWrapper.get(
      `merchant/designer/project/latestDesignConsept`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailProject = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/detailByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailProjectByOrderNo = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/projectDetailByOrderNumber`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const addDesignConceptProject = async (payload) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchant/designer/project/createNewDesignConceptByOrderId_v4`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProjectNote = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/updateNotedByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProjectStatus = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/updateStatusByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const approveProjectBudgetCustom = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/order/custom/approve`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDesignPlanList = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/detailDesignPlanByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDesignPlanListCustom = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/custom/detailDesignPlanByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailDesignConcept = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/subDetailDesignPlanByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateDesignConceptProject = async (payload) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchant/designer/project/updateDesignConceptByOrderId_v4`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const submitDesignConcept = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/updateSubmitConcept`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getFinalDesignList = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/detailDesignFinalByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProjectQuotation = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/updatePriceByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getFinalDesignMaterial = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/custom/detailDesignPlanByOrderId`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const createMaterialList = async (payload) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchant/designer/project/createNewDesignConceptByOrderId_v4`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const updateMaterialList = async (payload) => {
  try {
    const response = await apiWrapper.multipartPost(
      `merchant/designer/project/updateDesignConceptByOrderId_v4`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getProjectRoomTypes = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchant/designer/project/roomType`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};
